export interface DigiResponse<T> {
    statusCode: StatusCode;
    metaData: { [key: string]: string };
    body: T | null;
}

export interface StatusCode {
    status: string; // e.g., "OK", "FAILED"
    reason?: string;
}

export const DIGI_RESPONSE_KEYS = {
    IDENTIFIER: "Identifier",
    TOKEN: "Token",
    USER_ACCOUNT_ID: "UserAccountId",
    SCHOOL_ACCOUNT_ID: "SchoolAccountId",
} as const;

export interface CarerInfo {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber?: string;   
}